import produce from 'immer'
import { Reducer } from 'redux'

import {
  SET_IS_TILED_MENU,
  SET_TILED_MENU_IS_LOADED,
  SET_ACCORDION_IS_LOADED,
  SET_DASHBOARD_IS_LOADED,
  SET_HOMEPAGE_STORIES_IS_LOADED,
  SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  SET_SEARCH_RESULTS_LOADED,
  SET_ANNOTATIONS_LOADED,
  SET_HIDE_OVERRIDE
} from 'redux/actions/types'

export interface PlaceholdersState {
  isTiledMenu: boolean;
  isTiledMenuLoaded: boolean;
  isAccordionLoaded: boolean;
  isDashboardLoaded: boolean;
  isHomePageStoriesLoaded: boolean;
  isHomepageFcUpdatesLoaded: boolean;
  isSearchResultsLoaded: boolean;
  isAnnotationsLoaded: boolean;
  hideOverride: boolean;
}

const intialState: PlaceholdersState = {
  isTiledMenu: false,
  isTiledMenuLoaded: false,
  isAccordionLoaded: false,
  isDashboardLoaded: false,
  isHomePageStoriesLoaded: false,
  isHomepageFcUpdatesLoaded: false,
  isSearchResultsLoaded: false,
  isAnnotationsLoaded: false,
  hideOverride: false
}


const placeholders:Reducer<PlaceholdersState, any> = (state = intialState, action) => {
  switch (action.type) {
    case SET_IS_TILED_MENU:
      return produce(state, draft => {
        draft.isTiledMenu = action.isTiledMenu
      })
    case SET_TILED_MENU_IS_LOADED:
      return produce(state, draft => {
        draft.isTiledMenuLoaded = action.isLoaded
      })
    case SET_ACCORDION_IS_LOADED:
      return produce(state, draft => {
        draft.isAccordionLoaded = action.isLoaded
      })
    case SET_DASHBOARD_IS_LOADED:
      return produce(state, draft => {
        draft.isDashboardLoaded = action.isLoaded
      })
    case SET_HOMEPAGE_STORIES_IS_LOADED:
      return produce(state, draft => {
        draft.isHomePageStoriesLoaded = action.isLoaded
      })
    case SET_HOMEPAGE_FC_UPDATES_IS_LOADED:
      return produce(state, draft => {
        draft.isHomepageFcUpdatesLoaded = action.isLoaded
      })
    case SET_SEARCH_RESULTS_LOADED:
      return produce(state, draft => {
        draft.isSearchResultsLoaded = action.isLoaded
      })
    case SET_ANNOTATIONS_LOADED:
      return produce(state, draft => {
        draft.isAnnotationsLoaded = action.isLoaded
      })
    case SET_HIDE_OVERRIDE:
      return produce(state, draft => {
        draft.hideOverride = action.hideOverride
      })
    default:
      return state
  }
}

export default placeholders
